import { createContext } from 'react';
import { HubConnection } from '@microsoft/signalr';

export interface IHubContext {
    hubConnection: HubConnection | null;
}

export const HubContext = createContext<IHubContext | null>(null);